import { render, staticRenderFns } from "./TelegramCommunityCard.vue?vue&type=template&id=20c41f65&scoped=true&"
import script from "./TelegramCommunityCard.vue?vue&type=script&lang=js&"
export * from "./TelegramCommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./TelegramCommunityCard.vue?vue&type=style&index=0&id=20c41f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c41f65",
  null
  
)

export default component.exports